import { render } from "./chatbot.vue?vue&type=template&id=306fd68f&scoped=true"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"

import "./chatbot.vue?vue&type=style&index=0&id=306fd68f&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306fd68f"]])

export default __exports__